import React from 'react'
import PropTypes from 'prop-types'

const TableRowField = ({ label, value }) => {

    return (
        <div>
            <b className='mr-1'>{label}</b>
            <span>{value}</span>
        </div>
    )
}

TableRowField.propTypes = {
    label: PropTypes.string.isRequired,
    value: PropTypes.any
}

export default TableRowField




// WEBPACK FOOTER //
// ./src/components/Table/TableRowField/TableRowField.js